'use client';
import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { getComputerOnboardingV2 } from '#pplx/frontend/apps/ask/onboarding-computer/v2/api/computerOnboardingV2Api.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useCallback } from 'react';
export const LazyEnterpriseComputerOnboardingV2Modal = Dynamic(async () => {
    const { EnterpriseComputerOnboardingV2Modal } = await import('#pplx/frontend/apps/ask/onboarding-computer/v2/EnterpriseComputerOnboardingV2Modal.js');
    return { default: EnterpriseComputerOnboardingV2Modal };
});
export function useLaunchEnterpriseComputerOnboardingV2() {
    const { openModal } = useModalContext();
    const { update } = useSession();
    return useCallback(async ({ metadata, completeEnterpriseOnboarding }) => {
        try {
            await update();
            const response = await getComputerOnboardingV2({
                reason: 'enterprise-computer-onboarding-v2-terminal',
                subscriptionTier: metadata.subscriptionTier,
            });
            if (response.steps.length === 0) {
                return false;
            }
            openModal(LazyEnterpriseComputerOnboardingV2Modal, {
                metadata,
                completeEnterpriseOnboarding,
                preloadedResponse: response,
            }, { replace: true });
            return true;
        }
        catch (error) {
            logger.error('Failed to launch enterprise computer onboarding v2', error);
            return false;
        }
    }, [openModal, update]);
}
//# sourceMappingURL=useLaunchEnterpriseComputerOnboardingV2.js.map